declare const __BUILD_SHA__: string
;(globalThis as { __BUILD_SHA__?: string }).__BUILD_SHA__ = __BUILD_SHA__
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { initRUM } from '@secureembed/shared-crm'
import App from './App'
import { queryClient } from './lib/queryClient'
import './index.css'

initRUM('INNOVATEFLOW_CONFIG')

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
)
